import update from 'immutability-helper';
import {
  FETCH_MY_TRIP_LIST,
  FETCH_MY_TRIP_LIST_SUCCESS,
  FETCH_MY_TRIP_LIST_FAIL,
  FETCH_TRAVEL_GROUP_LIST,
  FETCH_TRAVEL_GROUP_LIST_SUCCESS,
  FETCH_TRAVEL_GROUP_LIST_FAIL,
  UPDATE_PUBLIC_STATUS_SUCCESS,
  UPDATE_PUBLIC_STATUS_FAIL,
  RESET_MY_TRIP_LIST,
  ADD_TRIP_SUCCESS,
  ADD_TRIP_FAIL,
  COPY_TRIP_FAIL,
  COPY_TRIP_SUCCESS,
  DELETE_TRIP_SUCCESS,
  DELETE_TRIP_FAIL,
  DELETE_SHARED_TRIP_SUCCESS,
  DELETE_SHARED_TRIP_FAIL,
  GET_COUNT_OF_INVITATIONS_SUCCESS,
  ACCEPT_SHARED_TRIP_FAIL,
  ACCEPT_SHARED_TRIP_SUCCESS,
  ACCEPT_SEND_ITINERARY_FAIL,
  ACCEPT_SEND_ITINERARY_SUCCESS,
  ERASE_TRIP_LIST,
  USER_LOG_OUT,
  REMOVE_MEMBER_FROM_GROUP_OF_MY_TRIPS,
} from './../actions/action_types';

export default (
  state = {
    byId: [],
    byHash: {},
    skip: 0,
    totalCount: 0,
    countOfInvitations: 0,
    invitations: [],
    error: null,
  },
  action,
) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_MY_TRIP_LIST:
      return { ...state };
    case FETCH_MY_TRIP_LIST_SUCCESS:
      return handleFetchTripListSuccess(state, payload.results);
    case FETCH_MY_TRIP_LIST_FAIL:
      return {
        ...state,
        error: payload,
      };
    case FETCH_TRAVEL_GROUP_LIST:
      return { ...state };
    case FETCH_TRAVEL_GROUP_LIST_SUCCESS:
      return handleFetchGroupTripList(state, payload.results);
    case FETCH_TRAVEL_GROUP_LIST_FAIL:
      return {
        ...state,
        error: payload,
      };
    case UPDATE_PUBLIC_STATUS_SUCCESS:
      return handleUpdatePublicStatusSuccess(state, payload);
    case UPDATE_PUBLIC_STATUS_FAIL:
      return {
        ...state,
        error: payload,
      };
    case COPY_TRIP_SUCCESS:
      return {
        ...state,
      };
    case ADD_TRIP_SUCCESS:
      return {
        ...state,
      };
    case COPY_TRIP_FAIL:
    case ADD_TRIP_FAIL:
      return {
        ...state,
        error: payload,
      };
    case RESET_MY_TRIP_LIST:
      return {
        byId: [],
        byHash: {},
        skip: 0,
        totalCount: 0,
        countOfInvitations: 0,
        invitations: [],
        error: null,
      };
    case DELETE_TRIP_SUCCESS:
      return handleDeleteTripSuccess(state, payload);
    case DELETE_TRIP_FAIL:
      return {
        ...state,
        error: payload,
      };
    case DELETE_SHARED_TRIP_SUCCESS:
      return handleDeleteSharedTripSuccess(state, payload);
    case DELETE_SHARED_TRIP_FAIL:
      return {
        ...state,
        error: payload,
      };
    case GET_COUNT_OF_INVITATIONS_SUCCESS:
      return {
        ...state,
        countOfInvitations:
          // hack 見單號 560 暫時解 之後可能會更改
          payload.results.sharedTripCount + payload.results.sendItineraryCount,
      };
    case ACCEPT_SHARED_TRIP_FAIL:
      return {
        ...state,
        error: payload,
      };
    case ACCEPT_SHARED_TRIP_SUCCESS:
      return handleAcceptSharedTripSuccess(state, payload);
    case ACCEPT_SEND_ITINERARY_FAIL:
      return {
        ...state,
        error: payload,
      };
    case ACCEPT_SEND_ITINERARY_SUCCESS:
      return handleSendItinerarySuccess(state, payload);
    case ERASE_TRIP_LIST:
      return {
        ...state,
        byId: [],
        byHash: {},
        skip: 0,
        totalCount: 0,
      };
    case USER_LOG_OUT:
      return {
        ...state,
        byId: [],
        byHash: {},
        skip: 0,
        totalCount: 0,
      };
    case REMOVE_MEMBER_FROM_GROUP_OF_MY_TRIPS:
      return handleRemoveMemberFromGroupOfMyTrips(state, payload);
    default:
      return state;
  }
};

const handleFetchTripListSuccess = (state, results) => {
  const idArray = [];
  const hash = {};
  results.trips.forEach(element => {
    if (element) {
      idArray.push(element._id);
      hash[element._id] = element;
    }
  });
  return {
    ...state,
    byId: [...state.byId, ...idArray],
    byHash: { ...state.byHash, ...hash },
    skip: parseInt(results.skip, 0),
    totalCount: parseInt(results.totalCount, 0),
  };
};

const handleFetchGroupTripList = (state, results) => {
  const idArray = [];
  const hash = {};
  results.trips.forEach(element => {
    if (element) {
      idArray.push(element._id);
      hash[element._id] = element;
    }
  });
  return {
    ...state,
    byId: [...state.byId, ...idArray],
    byHash: { ...state.byHash, ...hash },
    skip: parseInt(results.skip, 0),
    totalCount: parseInt(results.totalCount, 0),
    groupTripList: results.trips,
  };
};

const handleUpdatePublicStatusSuccess = (state, payload) => {
  const { tripObjectId, publicStatus } = payload;
  const newState = update(state, {
    byHash: {
      [tripObjectId]: {
        publicStatus: { $set: publicStatus },
      },
    },
  });
  return newState;
};

const handleDeleteTripSuccess = (state, payload) => {
  const { tripObjectId } = payload;
  const index = state.byId.indexOf(tripObjectId);
  const newState = update(state, {
    byId: { $splice: [[index, 1]] },
    byHash: { $unset: [tripObjectId] },
  });
  return newState;
};

const handleDeleteSharedTripSuccess = (state, payload) => {
  const { tripObjectId } = payload;
  const index = state.byId.indexOf(tripObjectId);
  const newState = update(state, {
    byId: { $splice: [[index, 1]] },
    byHash: { $unset: [tripObjectId] },
  });
  return newState;
};

const handleGetInvitationsSuccss = (state, payload) => {
  const {
    results: { sendItinerary, sharedTrip },
  } = payload;
  const itineraries = [];
  const trips = [];
  sendItinerary.forEach(obj => {
    itineraries.push({ ...obj, isSharedTrip: false });
  });
  sharedTrip.forEach(obj => {
    trips.push({ ...obj, isSharedTrip: true });
  });
  const newState = update(state, {
    invitations: { $set: [...trips, ...itineraries] },
  });
  return newState;
};

const handleAcceptSharedTripSuccess = (state, payload) => {
  const { objectId } = payload;
  const { invitations } = state;
  let index = null;
  for (let i = 0; i < invitations.length; i++) {
    const object = invitations[i];
    if (object._id === objectId) {
      index = i;
      break;
    }
  }
  const countOfInvitations = Number(state.countOfInvitations) - 1;
  if (index !== null) {
    const newState = update(state, {
      invitations: { $splice: [[index, 1]] },
      countOfInvitations: { $set: countOfInvitations },
    });
    return newState;
  }
  return state;
};

const handleSendItinerarySuccess = (state, payload) => {
  const { objectId } = payload;
  const { invitations } = state;
  let index = null;
  for (let i = 0; i < invitations.length; i++) {
    const object = invitations[i];
    if (object._id === objectId) {
      index = i;
      break;
    }
  }
  const countOfInvitations = Number(state.countOfInvitations) - 1;
  if (index !== null) {
    const newState = update(state, {
      invitations: { $splice: [[index, 1]] },
      countOfInvitations: { $set: countOfInvitations },
    });
    return newState;
  }
  return state;
};

const handleRemoveMemberFromGroupOfMyTrips = (state, payload) => {
  const { memberID, tripID } = payload;
  const { byHash } = state;
  const newMemberData = byHash[tripID].companions.filter(
    item => item.parseFriendObjectId !== memberID,
  );
  byHash[tripID].companions.length = 0;
  byHash[tripID].companions = [...newMemberData];
  const newState = {
    ...state,
    byHash,
  };
  return newState;
};
